export const FACET_SEPARATOR = ' > ';

export const SORT_VALUES = [
  'relevance',
  'price_desc',
  'price_asc',
  'release_date_asc',
  'release_date_desc',
];

export const CATALOG_MENU_HIERARCHY_NAME = 'catalogMenu';
